(function () {
  var CONFIG_EL_ID = 'free-gift-automation-config';
  var SOURCE_ID = 'free-gift-automation';

  function readConfig() {
    var el = document.getElementById(CONFIG_EL_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.error('[free-gift-automation] invalid config JSON', err);
      return null;
    }
  }

  // Shared cross-script cart-mutation queue. This automation script and the theme's
  // own cart components (see component-cart-items.js) both route their /cart/*.js
  // write requests through this same window-scoped queue, so that two independently
  // triggered cart mutations are never in flight at the same time. Shopify's AJAX
  // Cart API is not transactional across concurrent requests - two unrelated writes
  // racing against each other is a real, documented source of duplicate or lost cart
  // lines. Serializing every write here removes that risk regardless of which script
  // initiated it.
  function withCartLock(fn) {
    var next = (window.__cartMutationQueue || Promise.resolve()).then(fn, fn);
    window.__cartMutationQueue = next.catch(function () {});
    return next;
  }

  function init() {
    var config = readConfig();
    if (!config || !config.enabled) return;
    if (!config.giftVariantId) return;

    var triggerProductIds = config.triggerProductIds || [];

    var syncing = false;
    var pending = false;

    function getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
        return res.json();
      });
    }

    function addGift() {
      return withCartLock(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: config.giftVariantId,
              quantity: 1,
              properties: { _free_gift: 'belt-addon', 'Promotion': '🎁 Summer Sale Gift' },
            }],
          }),
        });
      });
    }

    // Updates a cart line's quantity by its stable line item key (variant + properties
    // hash) rather than its positional index. The index shifts whenever any other line
    // is added, removed, or reordered elsewhere in the cart, which previously risked
    // this call landing on the wrong line and creating a duplicate instead of updating
    // the intended one.
    function setLineQuantityByKey(key, quantity) {
      return withCartLock(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
      });
    }

    function isGiftItem(item) {
      return (
        item.variant_id === config.giftVariantId &&
        item.properties &&
        item.properties._free_gift === 'belt-addon'
      );
    }

    // A cart line counts as a trigger only if its product is in the configured
    // trigger collection (section setting: "Trigger collection"). Falls back to
    // "any non-gift item counts" only when no trigger collection was configured at
    // all, so existing setups without the setting keep working unchanged.
    function isTriggerItem(item) {
      if (isGiftItem(item)) return false;
      if (triggerProductIds.length === 0) return true;
      return triggerProductIds.indexOf(item.product_id) !== -1;
    }

    function broadcastCartUpdate(cart) {
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: SOURCE_ID, data: {} },
        }));
      } catch (err) {}
    }

    function sync() {
      if (syncing) { pending = true; return; }
      syncing = true;

      getCart()
        .then(function (cart) {
          var items = cart.items || [];

          var triggerPresent = items.some(isTriggerItem);

          // Find the managed gift line (if any) and keep its stable key, not its index.
          var giftItem = null;
          items.forEach(function (item) {
            if (isGiftItem(item)) giftItem = item;
          });

          var ops = Promise.resolve();
          var changed = false;

          // Add gift if trigger present and gift not already in cart
          if (triggerPresent && !giftItem) {
            ops = ops.then(function () {
              changed = true;
              return addGift();
            });
          }

          // Remove gift if no trigger product remains - by key, no refetch needed
          if (!triggerPresent && giftItem) {
            ops = ops.then(function () {
              changed = true;
              return setLineQuantityByKey(giftItem.key, 0);
            });
          }

          // Clamp gift quantity to 1 - by key
          if (triggerPresent && giftItem && giftItem.quantity > 1) {
            ops = ops.then(function () {
              changed = true;
              return setLineQuantityByKey(giftItem.key, 1);
            });
          }

          return ops.then(function () {
            if (!changed) return { cart: cart, changed: false };
            return getCart().then(function (updatedCart) {
              return { cart: updatedCart, changed: true };
            });
          });
        })
        .then(function (result) {
          if (result && result.changed) broadcastCartUpdate(result.cart);
        })
        .catch(function (err) {
          console.error('[free-gift-automation] sync failed', err);
        })
        .finally(function () {
          syncing = false;
          if (pending) { pending = false; sync(); }
        });
    }

    document.addEventListener('cart:update', function (event) {
      if (event && event.detail && event.detail.sourceId === SOURCE_ID) return;
      sync();
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
